module.exports = __webpack_public_path__ + "img/308.7b7c8d88.png";